require('./cardLastMovementsHeader.scss');

const PropTypes = require('prop-types');

const React = require('react');
const { formatText } = require('core/i18n').i18n;
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { toFirstUppercase } = require('utilities/stringHelper');
// @Components
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKButton } = require('components/commons/OKButton/OKButton');

class CardLastMovementsHeader extends React.Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        const {
            downloadButton,
            onFilterClick
        } = this.props;
        let headerTitle = (
            <div>
                {toFirstUppercase(formatText('cards-movements'))}
            </div>
        );

        return (
            <header className="card-last-movements-header">
                <div className="card-last-movements-header__title">
                    <OKBoxTitle value={headerTitle} />
                </div>
                <div className="card-last-movements-header__filters">
                    <OKButton modifier="task" onClick={onFilterClick}>
                        <i className="icon icon-filtrar card-last-movements-header__filter-settings-icon" />
                    </OKButton>
                    {downloadButton}
                </div>
            </header>
        );
    }
}

CardLastMovementsHeader.propTypes = {
    onFilterClick: PropTypes.func,
    downloadButton: PropTypes.any
}

module.exports = CardLastMovementsHeader;
